<template>
	<div class="">
		<div class="w-full bg-white h-[74px]">
			<examHeader :title="title"></examHeader>
			<div  class="2xl:w-[1200px] xl:w-[1200px] lg:w-[1000px] mx-auto flex justify-between">
				<div class="lg:w-[700px] 2xl:w-[900px] xl:w-[900px] h-[78vh]  mr-[10px] flex flex-col ">
					<div :style="{ backgroundImage: svgWatermark1+watermarkContent+svgWatermark2}"
						class="  w-full max-h-[100%] min-h-[50%]  overflow-y-auto  bg-repeat  shadow-01 rounded-[6px] mb-[10px] bg-white py-[30px] px-[16px] box-border">
						<div class="">
							<div class="flex  mb-[20px]">
								<el-tooltip class="item" effect="dark"
									:content="currentTopicInfo.is_user_collection==1?langInfo.cancel_collect:langInfo.click_collect"
									placement="bottom">
									<img @click="collectClick()"
										:src="currentTopicInfo.is_user_collection==1?collectActive:collectImg"
										class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />
								</el-tooltip>
								<img @click="questionClick()"
									:src="currentTopicInfo.is_user_question==1?questionActive:questionImg"
									class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />
								<div class="flex-1 text-[18px] text-[#101010] font-semibold flex">
									{{currentTopic + 1 }}.<span v-html="currentTopicInfo.content"
										class="whitespace-pre-wrap"></span>
								</div>
							</div>
							<div class="pl-[68px] box-border text-[#101010]">
								<div @click="selectClick(item,index)" v-for="(item,index) in optionsList"
									class="flex items-center mb-[10px] cursor-pointer">
									<img :src="item.isSelect?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{item.key}}.</label><label
										class="cursor-pointer" v-html="item.value"></label>
								</div>
							</div>
						</div>
					</div>
					<div class="shadow-01 rounded-[6px] h-[56px] bg-white flex items-center justify-center">
						<div @click="preTopic()" :class="currentTopic==0?'bg-[#8FC3FF]':'bg-[#2979FF] '"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] mr-[14px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_pre}}
						</div>
						<div @click="nextTopic()"
							:class="currentTopic==topicList.length -1 ?'bg-[#8FC3FF]':'bg-[#2979FF]'"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_next}}
						</div>
					</div>
				</div>
				<div class="flex-1 h-[78vh]">
					<div class="h-[46vh] mb-[10px] flex flex-col  pb-[20px] box-border shadow-01 rounded-[6px]  bg-white overflow-hidden">
						<div
							class="answerSheetTitle bB-01  p-[20px] box-border relative text-[16px] text-[#1B2128] font-bold">
							{{langInfo.study_paper_card}}
						</div>
						<div class=" overflow-y-auto ">
							<div class="flex flex-wrap cursor-pointer py-[20px] px-[13px] box-border ">
								<div @click="selectTopic(item,index)"
									:class="[item.userrecord && item.userrecord.user_answer?'bg-[#ff9000] text-white':'',currentTopic==index?'bg-[#A6A6A6] text-white':'']"
									class="topicItem mb-[10px] cursor-pointer relative   flex items-center justify-center box-border"
									v-for="(item,index) in topicList" :key="index">
									
									<img v-if="item.question.is_user_question==1&&item.question.is_user_collection==1" src="@/static/image/icon55.png"
										class="w-[14px] h-[14px] absolute top-[0px] right-[0px]" alt="" srcset="" />
									<img v-else-if="item.question.is_user_question==1" src="@/static/image/icon55.png"
										class="w-[14px] h-[14px] absolute bottom-[0px] right-[0px]" alt="" srcset="" />
										
									<img v-if="item.question.is_user_collection==1" :src="collectActive"
										class="w-[14px] h-[14px] cursor-pointer absolute bottom-[0px] right-[0px]" alt="" srcset="" />
									<label  class="cursor-pointer"> {{index + 1 }}</label>
									
								</div>
							</div>

						</div>
					</div>
					<div
						class=" mb-[10px] h-[16vh] px-[16px] flex flex-col justify-center  shadow-01 rounded-[6px]  bg-white">
						<div class="text-[#686C73] flex items-center justify-center mb-[6px]">
							<img src="@/static/image/icon39.png" class="w-[20px] h-[20px]  mr-[10px]" alt="" />
							{{langInfo.study_paper_countdown}}
						</div>
						<div class="mb-[10px] text-[20px] font-bold text-[#E58039] text-center">
							{{remainingTime}}
						</div>
						<el-progress class="mb-[28px]" :text-inside="true" :stroke-width="10" :show-text="false"
							:percentage="percentage"></el-progress>
						<div class="flex items-center justify-between">
							<label class="text-[#E58039]">{{langInfo.study_paper_over}} {{finishNum}}
								{{langInfo.study_paper_count}}</label>
							<label
								class="text-[#686C73]">{{langInfo.study_paper_all}}{{topicList.length}}{{langInfo.study_paper_count}}</label>
						</div>
					</div>

					<div class="mb-[10px] shadow-01 rounded-[6px] h-[60px] bg-white flex items-center justify-center">
						<div @click="stopPaper()"
							class="bg-[#D86D21] w-[100px] h-[28px] leading-[28px] mr-[14px] text-center text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_stop}}
						</div>
						<div @click="handPaper()"
							class="bg-[#2979FF] w-[100px] h-[28px] leading-[28px] text-center text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_submit}}
						</div>
					</div>

					<div
						class="shadow-01 rounded-[6px]  bg-white leading-[17px] text-[#FF0000] text-[12px] py-[12px] px-[17px] box-border">
						{{langInfo.study_paper_tip}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import examHeader from '@/components/examHeader.vue'
	export default {
		components: {

			examHeader
		},
		data() {
			return {
				title: '',
				selectImg: require('@/static/image/icon37.png'),
				selectedImg: require('@/static/image/icon38.png'),

				collectActive: require('@/static/image/icon22Active.png'),
				collectImg: require('@/static/image/icon22.png'),

				questionActive: require('@/static/image/icon36Active.png'),
				questionImg: require('@/static/image/icon36.png'),
				// 选项
				optionsList: [],
				finishNum: 0, //完成数量
				// 当前题
				currentTopic: 0,
				currentTopicInfo: {
					id: '',
					content: '',
				},
				// 题列表
				topicList: [],

				// 倒计时
				remainingTime: '00:00:00',

				currentSecond: 0, //当前已用秒数
				percentage: 0, //进度
				countdownTimer: null,

				id: '',

				questionInfo: {},
				identification: '',
				order_item_id: '',
				examStatus: "", //考试状态:pending=待定,tentative=暂停,in_progress=继续,complete=完成

				langInfo: {},
				watermarkContent: JSON.parse(localStorage.getItem('userInfo')).username + '@' + this.$common.currentTime() + '@港考通',
				svgWatermark1: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='140'><text x='0' y='100' transform='rotate(-30, 40, 100)' fill='%23999' font-size='14' opacity='0.2'>`,
				svgWatermark2: `</text></svg>")`,
				type: '', //1 自由  2后台
				isFinish:false
			}
		},
		mounted() {
			// this.unloadshim()
			window.addEventListener('beforeunload', e => this.handleUnload(e))
			this.id = this.$route.query.id
			this.identification = this.$route.query.identification
			this.order_item_id = this.$route.query.order_item_id
			this.getQuestionInfo()


			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}




		},
		beforeDestroy() {
			window.removeEventListener('beforeunload', e => this.handleUnload(e));



			clearInterval(this.countdownTimer); // 停止定时器
			this.countdownTimer = null
			if (this.examStatus != 'complete') {
				this.stopStatus() //修改暂停状态
			}
		},

		destroyed() {
			console.log("销毁")
			clearInterval(this.countdownTimer); // 停止定时器
			this.countdownTimer = null

			console.log("销毁===========");

			localStorage.removeItem('currentTopic')

			if (this.examStatus != 'complete') {
				this.stopStatus() //修改暂停状态
			}
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			unloadshim() {
				window.onbeforeunload = (e) => {
					e = e || window.event;
					console.log("e=====");
					console.log(e);
					// 适配IE8, Firefox 4之前版本
					if (e) e.returnValue = '关闭提示';
					// 适配Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
					return '关闭提示';
				}
			},
			// 注入网页关闭/刷新/前进后退阻止器
			// 执行函数或方法
			handleUnload(e) {

				this.stopStatus() //修改暂停状态
			},

			handleBeforeUnload() {
				event.preventDefault();
				console.log("刷新");
				this.stopStatus() //修改暂停状态
			},
			getCurrentInfo() {
				this.currentTopicInfo = this.topicList[this.currentTopic].question
				
				this.optionsList = this.currentTopicInfo.options
				

				if (this.topicList[this.currentTopic].userrecord) {
					let userrecord = this.topicList[this.currentTopic].userrecord
					this.optionsList.forEach((item, index) => {
						this.$set(item,'isSelect',false)
						if (userrecord.user_answer == item.key) {
							item.isSelect = true
						}else{
							item.isSelect = false
						}
					})
				}
				else{
					console.log("无");
					this.optionsList.forEach((item, index) => {
						this.$set(item,'isSelect',false)
					})
				}
				
				
				this.currentTopicInfo.content = this.decodeHtml(this.currentTopicInfo.content)

				
				this.get_user_log()
			},
			
			decodeHtml(html) {
				if (!html) return ''
			
				const textarea = document.createElement('textarea')
				textarea.innerHTML = html
			
				return textarea.value
			},

			get_user_log() {
				this.$api.user_log({
					action: 'question',
					type: this.type,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},

			getAnsweredNum() {
				let num = 0
				this.topicList.forEach((item, index) => {
					console.log(item.userrecord);
					if (item.userrecord) {
						num++
					}
				})
				this.finishNum = num
				this.percentage = Number(this.finishNum) / Number(this.topicList.length) * 100
			},
			getQuestionInfo() {
				this.$api.getQuestion({
					id: this.id,
					identification: this.identification,
					order_item_id: this.order_item_id
				}).then((res) => {
					console.log(res);
					this.isFinish=true
					this.title = res.data.title
					
					document.title = this.title
					
					this.questionInfo = res.data

					this.type = res.data.type

					console.log("this.type====" + this.type);

					// is_user_collection=是否收藏0否1是
					res.data.question.forEach((item, index) => {
						item.question.options.forEach((itm, ind) => {
							this.$set(itm, 'isSelect', false)
						})
					})

					if (this.questionInfo.question_exam) {
						if (this.questionInfo.question_exam.status == "tentative") {
							this.stopShowPopup() //显示暂停弹框
						}
					}



					if (Number(localStorage.getItem('currentTopic'))) {
						this.currentTopic = Number(localStorage.getItem('currentTopic'))
					} else {
						this.currentTopic = res.data.key_
					}




					if (res.data.time >= 0) {
						this.countTime(res.data.time)
					}
					this.topicList = res.data.question
					this.getCurrentInfo()
					this.getAnsweredNum()
				}).catch((error) => {
					this.isFinish=true
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			getAnsweredInfo() {
				this.$api.getQuestion({
					id: this.id,
					identification: this.identification
				}).then((res) => {
					console.log(res);
					this.topicList = res.data.question
					this.getAnsweredNum()
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},
			selectClick(item, index) {
				console.log(item);
				this.optionsList.forEach((itm, ind) => {
					if (index == ind) {
						itm.isSelect = !itm.isSelect
					} else {
						itm.isSelect = false
					}
				})
				
				if (this.topicList[this.currentTopic].userrecord) {
					this.topicList[this.currentTopic].userrecord.user_answer=item.isSelect ? item.key : ''
				} else {
					this.topicList[this.currentTopic].userrecord={}
					this.topicList[this.currentTopic].userrecord.user_answer=item.isSelect ? item.key : ''
				}
				
				// this.getAnsweredInfo()
				this.getAnsweredNum()
				
				// question_paper_id=试卷id
				// course_question_id=题目id
				// user_answer=用户答案
				// mode=模式 模式:1=练习,2=错题,3=模拟考试
				// identification=试卷标识
				this.$api.recordQuestion({
					question_paper_id: this.id,
					course_question_id: this.topicList[this.currentTopic].id,
					user_answer: item.isSelect ? item.key : '',
					mode: 3,
					identification: this.questionInfo.identification
				}).then((res) => {
					console.log(res);
					
					
				
					
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},
			// 上一页
			preTopic() {
				if (this.currentTopic == 0) {
					return
				}
				this.currentTopic--

				localStorage.setItem('currentTopic', this.currentTopic)

				this.getCurrentInfo()
			},
			nextTopic() {
				if (this.currentTopic == this.topicList.length - 1) {
					return
				}


				this.currentTopic++

				localStorage.setItem('currentTopic', this.currentTopic)

				this.getCurrentInfo()
			},
			selectTopic(item, index) {
				this.currentTopic = index

				localStorage.setItem('currentTopic', this.currentTopic)

				this.getCurrentInfo()
			},

			countTime(duration) {
				let timer = duration,
					hour, minutes, seconds;
				hour = parseInt(timer / 60 / 60, 10);
				minutes = parseInt(timer / 60 % 60, 10);
				seconds = parseInt(timer % 60, 10);

				hour = hour < 10 ? "0" + hour : hour;
				minutes = minutes < 10 ? "0" + minutes : minutes;
				seconds = seconds < 10 ? "0" + seconds : seconds;
				this.remainingTime = `${hour}:${minutes}:${seconds}`;



				if (this.questionInfo.question_exam.status == "pending" || this.questionInfo.question_exam.status ==
					"in_progress") {
					this.startCountdown(duration);
				}

			},
			// 更新倒计时的函数

			startCountdown(duration) {
				let timer = duration,
					hour, minutes, seconds;
				const interval = 1000; // 1秒更新一次

				const timerFunction = () => {
					if (timer-- <= 0) {
						clearInterval(this.countdownTimer); // 停止定时器
						this.countdownTimer = null
						console.log("时间到了");
						this.examEnd()
						return
					}
					hour = parseInt(timer / 60 / 60, 10);
					minutes = parseInt(timer / 60 % 60, 10);
					seconds = parseInt(timer % 60, 10);

					hour = hour < 10 ? "0" + hour : hour;
					minutes = minutes < 10 ? "0" + minutes : minutes;
					seconds = seconds < 10 ? "0" + seconds : seconds;
					this.remainingTime = `${hour}:${minutes}:${seconds}`
					this.currentSecond++


				};
				timerFunction()
				this.countdownTimer = setInterval(timerFunction, interval);
			},
			examEnd() {
				console.log("考试结束");
			},
			// 暂停
			stopPaper() {
				console.log("暂停");
				clearInterval(this.countdownTimer); // 停止定时器
				this.countdownTimer = null
				// pause=暂停,resume=继续,complete=完成
				this.$api.updateExamStatus({
					action: 'pause',
					identification: this.questionInfo.identification
				}).then((res) => {
					this.stopShowPopup() //显示暂停弹框
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			stopStatus() {
				// pause=暂停,resume=继续,complete=完成
				this.$api.updateExamStatus({
					action: 'pause',
					identification: this.questionInfo.identification
				}).then((res) => {
					console.log(res);
				}).catch((error) => {

				})
			},

			stopShowPopup() {
				var that = this
				this.$alert(
					this.langInfo.study_paper_tip,
					this.langInfo.study_paper_stop_tip, {
						confirmButtonText: this.langInfo.study_exam_continue,
						callback: action => {
							console.log(action);
							if (action == 'confirm') {
								// pause=暂停,resume=继续,complete=完成
								this.$api.updateExamStatus({
									action: 'resume',
									identification: this.questionInfo.identification
								}).then((res) => {
									console.log(res);
									that.getExamTime() //获取考试时间

									this.$message({
										message: res.msg,
										type: 'success'
									})
								}).catch((error) => {
									this.$message({
										message: error.msg,
										type: 'warning'
									})
								})
							}
						}
					});
			},

			getExamTime() {
				this.$api.getQuestion({
					id: this.id,
					identification: this.identification
				}).then((res) => {
					console.log(res);
					this.questionInfo = res.data
					if (res.data.time >= 0) {
						this.countTime(res.data.time)
					}
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},
			// 交卷
			handPaper() {
				console.log("交卷");
				clearInterval(this.countdownTimer); // 停止定时器
				this.countdownTimer = null

				this.$confirm(this.langInfo.phone_finish_paper_tip, this.langInfo.reg_tip, {
					confirmButtonText: this.langInfo.study_paper_confirm,
					cancelButtonText: this.langInfo.cancel,
					type: 'info'
				}).then(() => {
					this.examStatus = 'complete'
					this.completePaper()
				}).catch(() => {

				});
			},
			completePaper() {
				this.$api.updateExamStatus({
					action: 'complete',
					identification: this.questionInfo.identification
				}).then((res) => {
					this.$message({
						message: res.msg,
						type: 'success'
					})
					setTimeout(() => {
						this.$router.push({
							path: '/exam/examOver',
							query: {
								id: res.data.id,
								identification: this.identification,
								order_item_id: this.order_item_id
							}
						})
					}, 800)
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},

			// 收藏
			collectClick() {
				console.log(12121);
				if (this.currentTopicInfo.is_user_collection == 1) {
					this.currentTopicInfo.is_user_collection = 0
				} else {
					this.currentTopicInfo.is_user_collection = 1
				}
				this.topicList[this.currentTopic].question.is_user_collection = this.currentTopicInfo.is_user_collection

				// type=类型:1=课程,2=咨询,3=资源,4=题目
				// course_course_id=课程id
				// course_question_id=题目id
				this.$api.addUserCollection({
					type: 4,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
					// status=0 0是取消1是收藏成功
					if (res.data.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 疑问标记
			questionClick() {
				if (this.currentTopicInfo.is_user_question == 1) {
					this.currentTopicInfo.is_user_question = 0
				} else {
					this.currentTopicInfo.is_user_question = 1
				}
				this.topicList[this.currentTopic].question.is_user_question = this.currentTopicInfo.is_user_question

				// type=类型:1=课程,2=咨询,3=资源,4=题目  5 疑问
				// course_course_id=课程id
				// course_question_id=题目id
				this.$api.addUserCollection({
					type: 5,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
					// status=0 0是取消1是收藏成功、疑问
					if (res.data.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			}

		}
	}
</script>

<style scoped>
	
	/deep/p img {
		width: 100% !important;
	}
	
	/* ::-webkit-scrollbar {
		display: none;
	} */

	.answerSheetTitle::after {
		content: '';
		position: absolute;
		width: 4px;
		height: 21px;
		background-color: rgba(103, 194, 58, 1);
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}

	.topicItem:nth-child(5n) {
		margin-right: 0;

	}

	.topicItem {
		width: 18%;
		height: 30px;
		line-height: 30px;
		margin-right: 2.5%;
		border: 1px solid rgba(187, 187, 187, 1);
	}
</style>